export const taxSettingsConstants = {
    TAX_ADD_SETTINGS_REQUEST: 'TAX_ADD_SETTINGS_REQUEST',
    TAX_ADD_SETTINGS_SUCCESS: 'TAX_ADD_SETTINGS_SUCCESS',
    TAX_ADD_SETTINGS_FAILURE: 'TAX_ADD_SETTINGS_FAILURE',

    GET_ALL_TAX_SETTINGS_REQUEST: 'GET_ALL_TAX_SETTINGS_REQUEST',
    GET_ALL_TAX_SETTINGS_SUCCESS: 'GET_ALL_TAX_SETTINGS_SUCCESS',
    GET_ALL_TAX_SETTINGS_FAILURE: 'GET_ALL_TAX_SETTINGS_FAILURE',

    TAX_EDIT_SETTINGS_REQUEST: 'TAX_EDIT_SETTINGS_REQUEST',
    TAX_EDIT_SETTINGS_SUCCESS: 'TAX_EDIT_SETTINGS_SUCCESS',
    TAX_EDIT_SETTINGS_FAILURE: 'TAX_EDIT_SETTINGS_FAILURE',

    TAX_DELETE_SETTINGS_REQUEST: 'TAX_DELETE_SETTINGS_REQUEST',
    TAX_DELETE_SETTINGS_SUCCESS: 'TAX_DELETE_SETTINGS_SUCCESS',
    TAX_DELETE_SETTINGS_FAILURE: 'TAX_DELETE_SETTINGS_FAILURE',


};
